import { ReactElement } from 'react';

import { OnboardingProgressBar } from './OnboardingProgressBar/OnboardingProgressBar';
import { Sidebar } from './Sidebar';

export const OnboardingLayout = ({ children }: { children: ReactElement }) => {
    return (
        <div className="mt-[-72px] grid grid-cols-8 bg-structure-100">
            <div className="col-span-2">
                <Sidebar />
            </div>
            <div className="col-span-6 grid grid-cols-4 py-2xl">
                <div className="col-span-2 col-start-2">
                    <OnboardingProgressBar />
                    {children}
                </div>
            </div>
        </div>
    );
};
